import { ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { LayoutPrintFormService } from "../layout-print-form/layout-print-form.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { QrCodeService } from "../qr-code/qr-code.service";
var PrintQrcodeComponent = (function () {
    function PrintQrcodeComponent(route, sanitizer, layoutPrintFormService, toastr, vcr, router, qrCodeService) {
        this.route = route;
        this.sanitizer = sanitizer;
        this.layoutPrintFormService = layoutPrintFormService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.qrCodeService = qrCodeService;
        this.css = '';
        this.toastr.setRootViewContainerRef(vcr);
        this.configCss = {
            '.layout-print': {
                'width': { value: [10.3], unit: 'cm' }
            },
            '.item-sm': {
                'width': { value: [5], unit: 'cm' },
                'height': { value: [4], unit: 'cm' },
                'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
            },
            '.item-lg': {
                'width': { value: [5], unit: 'cm' },
                'height': { value: [5], unit: 'cm' },
                'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
            },
            '.info-sm': {
                'font-size': { value: [10], unit: 'pt' },
                'line-height': { value: [0.85], unit: '' },
            },
            '.info-lg': {
                'font-size': { value: [12], unit: 'pt' },
                'line-height': { value: [1], unit: '' },
            },
            '.sub-info-lg': {
                'font-size': { value: [12], unit: 'pt' },
                'height': { value: [0.5], unit: 'cm' },
                'line-height': { value: [0.9], unit: '' }
            },
            'qrcode-sm': { value: [1.6], unit: 'cm' },
            'qrcode-lg': { value: [1.9], unit: 'cm' }
        };
    }
    PrintQrcodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.printData = new Array();
        this.initData();
        this.route.paramMap.subscribe(function (params) {
            _this.idLayout = params.get('id');
            _this.getLayoutPrintById();
            // this.renderCss();
        });
    };
    PrintQrcodeComponent.prototype.getLayoutPrintById = function () {
        var _this = this;
        this.isLoading = true;
        this.layoutPrintFormService.getLayoutPrint(this.idLayout)
            .then(function (res) {
            if (res.status === 1) {
                _this.layoutPrint = res.data;
                _this.configCss = JSON.parse(_this.layoutPrint.jsonCss);
                _this.renderCss();
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        }).catch(function (err) { return console.log(err); });
    };
    PrintQrcodeComponent.prototype.renderCss = function () {
        // this.configCss['.item-sm']['height'].value[0] = this.configCss['.item-sm']['padding'].value[0] + this.configCss['.item-sm']['padding'].value[2] + this.configCss['qrcode-sm'].value[0];
        // this.configCss['.item-lg']['height'].value[0] = this.configCss['.item-lg']['padding'].value[0] + this.configCss['.item-lg']['padding'].value[2] + this.configCss['.sub-info-lg']['height'].value[0] + this.configCss['qrcode-lg'].value[0];
        // this.configCss['.layout-print']['width'].value[0] = 2 * this.configCss['.item-sm']['width'].value[0] + 0.3;
        this.css = '';
        for (var key1 in this.configCss) {
            if (key1 === 'qrcode-sm' || key1 === 'qrcode-lg') {
                continue;
            }
            var temp = '';
            for (var key2 in this.configCss[key1]) {
                if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 1) {
                    temp += "\n          " + key2 + ": " + this.configCss[key1][key2].value + this.configCss[key1][key2].unit + ";";
                }
                if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 4) {
                    temp += key2 + ": " + this.configCss[key1][key2].value[0] + this.configCss[key1][key2].unit + " " + this.configCss[key1][key2].value[1] + this.configCss[key1][key2].unit + " " + this.configCss[key1][key2].value[2] + this.configCss[key1][key2].unit + " " + this.configCss[key1][key2].value[3] + this.configCss[key1][key2].unit + ";";
                }
            }
            this.css += "\n      " + key1 + " {" + temp + "\n      }";
        }
        this.style = this.sanitizer.bypassSecurityTrustHtml('<style>' + this.css + '</style>');
    };
    PrintQrcodeComponent.prototype.initData = function () {
        this.isLoading = true;
        var data = JSON.parse(localStorage.getItem('printData'));
        if (data !== null) {
            var printedID = [];
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                printedID.push(item.serialId);
            }
            this.qrCodeService.setUsedQrCode(printedID, true).then(function (res) {
                console.log(res);
            }).catch(function (err) { return console.log(err); });
            this.printData = data;
        }
        else {
            this.isLoading = false;
        }
    };
    //print theo so luong qrcode
    PrintQrcodeComponent.prototype.parseData = function (data) {
        for (var i = 0; i < data.length; i++) {
            var count = 0;
            while (count < data[i].numberPerCode) {
                this.printData.push(data[i]);
                count++;
            }
            this.printData.push(data[i]);
        }
        this.isLoading = false;
    };
    PrintQrcodeComponent.prototype.print = function () {
        localStorage.setItem("layout", JSON.stringify(this.layout));
        window.print();
    };
    return PrintQrcodeComponent;
}());
export { PrintQrcodeComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/print-qrcode/print-qrcode.component.ts.pre-build-optimizer.js